import React from 'react'
import './Style/Product.css'
import ReactHTMLTableToExcel from "react-html-table-to-excel";
function Product({data,DateDay}) {
  return <div className="table">
     <table id='table-invoice'>
            <tr>
                <th>SL.</th>
                <th>Item Description</th>
                <th>Price</th>
                <th>Qty.</th>
                <th>Total</th>
            </tr>
            {data.map((item,key)=>(
                <tr key={key}>
                      <td className='td-first'>{item.id} </td>
                      <td className='td-first'>{item.description} </td>
                      <td className='td-center'> ${item.price} </td>
                      <td className='td-center'> {item.qty} </td>
                      <td className='td-end'> ${item.price * item.qty} </td>
                </tr>
            ))}
        </table>
        <div className='button-export-to-exsel'>
        <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-invoice"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Print To Excel"
        />
    </div>     
      <hr/>
</div>
}

export default Product